/**
 * XML formatted, UTF-8 encoded, text header.
 *
 * @group DRM
 *
 * @beta
 */
export const TEXT_XML_UTF8 = 'text/xml; charset=utf-8';
//# sourceMappingURL=TEXT_XML_UTF8.js.map